import ControleSessao from "../../componentes-padrao/ControleSessao";
import backgroundLogin from "../../img/background_login.png";
import favicon from "../../img/favicon.png";
import loadingLogae from "../../img/eponto-loading-letras-transparente.gif";
import logoPrincipal from "../../img/logo_principal.png";
import logoToolbar from "../../img/logo_toolbar.png";

import { getDomainThemeData, getUserThemeData } from "./api";
import { montarTokensDerivados } from "./tokensDerivados";

export const DEFAULT_THEME = {
    primary_color: "#064635",
    primary_text_color: "#fff",
    secondary_color: "#1cb987",
    secondary_text_color: "#fff",
    login_logo: `url(${logoPrincipal})`,
    login_background_image: `url(${backgroundLogin})`,
    toolbar_image: `url(${logoToolbar})`,
    favicon: `${favicon}`,
    loading_svg: `${loadingLogae}`,
    tab_title: "e.ponto - Logae",
};

export const setUserTheme = async () => {
    let theme = DEFAULT_THEME;

    const domainThemeData = await getDomainThemeData(window.location.hostname);

    if (domainThemeData) {
        theme = domainThemeData;
    }

    const userThemeData = await getUserThemeData();

    if (userThemeData) {
        theme = userThemeData;
    }

    const customTitle = theme.tab_title ?? "e.ponto - Logae";

    document.title = customTitle;

    ControleSessao.setCustomTitle(customTitle);

    const root = $(":root");

    root.css({
        "--dx-theme-primary-color": theme.primary_color,
        "--dx-theme-primary-text-color": theme.primary_text_color,
        "--dx-theme-secondary-color": theme.secondary_color,
        "--dx-theme-secondary-text-color": theme.secondary_text_color,
        "--dx-theme-logo-login": theme.login_logo,
        "--dx-theme-imagem-bg": theme.login_background_image,
        "--dx-theme-logo-toolbar": theme.toolbar_image,

        // Tons do menu lateral que o tema não expõe, derivados da marca em uso
        // para acompanharem o White Label (JOR4-7365). Os mesmos valores estão
        // como fallback em css/menu-ds.css, para as telas anteriores ao login.
        ...montarTokensDerivados(theme),
        // Sem white label, `theme` é o DEFAULT_THEME e o valor é o GIF da Logae;
        // com white label e campo preenchido, é o arquivo do cliente. Com white
        // label e campo nulo — o estado de todo tenant já cadastrado, já que a
        // coluna nasce nula — vai `none`, e o LoadingWhiteLabel desenha um
        // círculo nas cores do tenant. Aqui não dá para cair no GIF da Logae,
        // que é a marca errada, nem para usar um arquivo colorido pelo tema: em
        // `background-image` o arquivo é documento isolado e as custom
        // properties não o alcançam.
        "--dx-theme-logo-loading": theme.loading_svg
            ? `url(${theme.loading_svg})`
            : "none",
    });

    let link = document.querySelector("link[rel~='icon']");
    if (link && theme.favicon) link.href = theme.favicon;
};
